import { render, staticRenderFns } from "./searchDetails.vue?vue&type=template&id=591a883a&scoped=true&"
import script from "./searchDetails.vue?vue&type=script&lang=js&"
export * from "./searchDetails.vue?vue&type=script&lang=js&"
import style0 from "./searchDetails.vue?vue&type=style&index=0&id=591a883a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a883a",
  null
  
)

export default component.exports